module.exports = "<ng-content></ng-content>"


//////////////////
// WEBPACK FOOTER
// ./src/app/_common/modal/modal.component.html
// module id = ./src/app/_common/modal/modal.component.html
// module chunks = main